import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const MenuItem = React.forwardRef(
    (
        {
            asElement: Component = 'div',
            children,
            className,
            disabled,
            eventKey,
            isActive,
            menuItemHeight = 35,
            onSelect,
            style,
            variant = 'light',
            ...rest
        },
        ref,
    ) => {
        const menuItemActiveClass = `menu-item-active`
        const menuItemHoverClass = `menu-item-hoverable`
        const disabledClass = 'menu-item-disabled'
        const menuItemClass = classNames(
            'menu-item',
            `menu-item-${variant}`,
            isActive && menuItemActiveClass,
            disabled && disabledClass,
            !disabled && menuItemHoverClass,
            className,
        )

        const hanldeOnClick = (e) => {
            if (onSelect) {
                onSelect(eventKey, e)
            }
        }

        return (
            <Component
                ref={ref}
                className={menuItemClass}
                style={{height: `${menuItemHeight}px`, ...style}}
                onClick={hanldeOnClick}
                {...rest}
            >
                {children}
            </Component>
        )
    },
)

MenuItem.propTypes = {
    asElement: PropTypes.string,
    menuItemHeight: PropTypes.number,
    disabled: PropTypes.bool,
    isActive: PropTypes.bool,
    eventKey: PropTypes.string,
    variant: PropTypes.oneOf(['light', 'dark', 'themed', 'transparent']),
}

export default MenuItem
